import { ATTRACTION_LADDER, catalogItem } from '../config/catalog';
import type { EntityKind, ParkState } from '../types';
import { hasBuiltKind } from './unlocks';

/** Shared Snack + Drink capacity from distinct attraction kinds ever built. */
export function kioskCapacityForDistinctAttractionKinds(distinctAttractionKinds: number): number {
  return distinctAttractionKinds === 0 ? 0 : distinctAttractionKinds + 1;
}

export function distinctAttractionKindCount(state: ParkState): number {
  return ATTRACTION_LADDER.filter((kind) => hasBuiltKind(state, kind)).length;
}

export function kioskCapacity(state: ParkState): number {
  return kioskCapacityForDistinctAttractionKinds(distinctAttractionKindCount(state));
}

export function isKioskKind(kind: EntityKind): boolean {
  return catalogItem(kind).role === 'kiosk';
}

export function kioskCount(state: ParkState): number {
  return state.entities.filter((entity) => isKioskKind(entity.kind)).length;
}

export function evaluateKioskPlacement(
  state: ParkState,
  kind: EntityKind,
): { ok: true } | { ok: false; reason: 'kiosk_capacity' } {
  if (!isKioskKind(kind)) {
    return { ok: true };
  }
  if (kioskCount(state) >= kioskCapacity(state)) {
    return { ok: false, reason: 'kiosk_capacity' };
  }
  return { ok: true };
}

/** Catalog explanation kind for the shared Snack + Drink pool. */
export function kioskCapUiKind(state: ParkState): 'open' | 'first' | 'grow' | 'final' {
  if (distinctAttractionKindCount(state) === 0) {
    return 'first';
  }
  if (kioskCount(state) < kioskCapacity(state)) {
    return 'open';
  }
  return distinctAttractionKindCount(state) >= ATTRACTION_LADDER.length ? 'final' : 'grow';
}
